"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Selectors_1 = require("../../Utility/Selectors");
HTMLElement.prototype.query = function query(selector) {
    const result = this.querySelector(selector);
    if (result === null) {
        throw new Error('Unable to locate element for selector: ' + selector);
    }
    return result;
};
HTMLElement.prototype.queryPromise = function queryPromise(selector) {
    return new Promise((resolve) => {
        const result = this.querySelector(selector);
        if (result !== null) {
            resolve(result);
        }
    });
};
HTMLElement.prototype.queryRole = function queryRole(role) {
    var _a;
    return this.query((_a = Selectors_1.default.createDataRoleSelector(role)) !== null && _a !== void 0 ? _a : '');
};
HTMLElement.prototype.queryRolePromise = function queryRole(role) {
    var _a;
    return this.queryPromise((_a = Selectors_1.default.createDataRoleSelector(role)) !== null && _a !== void 0 ? _a : '');
};
HTMLElement.prototype.queryRoleAll = function queryRoleAll(role) {
    var _a;
    return this.querySelectorAll((_a = Selectors_1.default.createDataRoleSelector(role)) !== null && _a !== void 0 ? _a : '');
};
HTMLElement.prototype.queryData = function queryData(key, value) {
    if (value) {
        return this.query('[data-' + key + '="' + value + '"]');
    }
    return this.query('[data-' + key + ']');
};
HTMLElement.prototype.closestRole = function closestRole(value) {
    const result = this.closest('[data-role="' + value + '"]');
    if (result === null) {
        throw new Error('Unable to locate parent element for role: ' + value);
    }
    return result;
};
//# sourceMappingURL=Query.js.map